import { Fragment } from "react";
import { CtaItem } from "~components/cms/cta-item/cta-item";
import { Button } from "~components/ui";
import { getLinkProps } from "~lib/storyblok";
import type { TileSectionProps } from "../types";

function TileSectionCTA({ blok, ...context }: TileSectionProps) {
  const showSingleCTA = !blok.ctaItems?.length && blok.ctaText && blok.ctaLink;
  const showCTASection = showSingleCTA || !!blok?.ctaItems?.length;

  return showCTASection ? (
    <Fragment>
      {showSingleCTA && (
        <Button
          arrow
          variant="secondary"
          className="mr-auto"
          {...getLinkProps(blok?.ctaLink ?? null, context)}
        >
          {blok.ctaText}
        </Button>
      )}

      {blok?.ctaItems?.map(blok => (
        <CtaItem className="mr-auto" key={blok._uid} blok={blok} {...context} />
      ))}
    </Fragment>
  ) : null;
}

export { TileSectionCTA };
